import React from 'react';
import { Link } from 'react-router-dom';
import { FaHeart, FaShoppingCart } from 'react-icons/fa';
import { useStore } from '../context/StoreContext';

const formatCurrency = (amount) => {
    return `KES ${Math.floor(amount).toLocaleString('en-US')}`;
};

const ProductCard = ({ product }) => {
    const { addToCart } = useStore();

    if (!product) return null;

    const imageUrl = product.imageUrl || '/placeholder_image.png';

    const handleAddToCart = (e) => {
        e.preventDefault(); 
        addToCart(product);
    };

    const handleAddToWishlist = (e) => {
        e.preventDefault();
        console.log(`Adding ${product.name} to wishlist!`);
    };

    return (
        <Link to={`/product/${product.id}`} className="group bg-white rounded-lg shadow-lg overflow-hidden flex flex-col justify-between transition-transform transform hover:-translate-y-1 hover:shadow-2xl">
            <div className="relative h-48">
                <img src={imageUrl} alt={product.name} className="w-full h-full object-contain p-4 transition-transform duration-300 group-hover:scale-105" />
            </div>
            
            <div className="p-4 flex-grow flex flex-col justify-between">
                <div>
                    <h3 className="text-lg font-semibold text-gray-800 h-14 overflow-hidden">{product.name}</h3>
                    
                    <div className="my-3 flex items-center justify-between">
                        <p className="text-xl font-bold text-red-600">
                            {formatCurrency(product.price)}
                        </p>
                        <span className="bg-blue-100 text-blue-800 text-xs font-semibold px-2.5 py-0.5 rounded-full">
                            {product.category}
                        </span>
                    </div>
                </div>

                <div className="mt-4 flex gap-2">
                    <button 
                        className="flex-1 bg-yellow-400 text-blue-900 font-bold py-2 px-4 rounded-md hover:bg-yellow-300 transition-all duration-300 flex items-center justify-center gap-2" 
                        onClick={handleAddToCart}
                        aria-label={`Add ${product.name} to Cart`}
                    >
                        <FaShoppingCart /> Add to Cart
                    </button>
                    <button 
                        className="bg-gray-200 text-gray-700 p-3 rounded-md hover:bg-red-100 hover:text-red-500 transition-all duration-300"
                        onClick={handleAddToWishlist}
                        aria-label={`Add ${product.name} to Wishlist`}
                    >
                        <FaHeart />
                    </button>
                </div>
            </div>
        </Link>
    );
};

export default ProductCard;